export type RoseWarning = string[]

export const RoseWarning = {
  deserialize(rawMessage?: string): RoseWarning {
    if (!rawMessage) {return [];}

    return rawMessage.split('\n').map((msg) => msg.trim());
  }
};
